export default __webpack_public_path__ + "static/media/frog-6.ef77ac84.png";